import React, { Component } from 'react';
import SimpleBar from 'simplebar-react';
import 'simplebar/dist/simplebar.min.css';
import Modal from './Modal';
import Contact from './Contact';

const modalContent = <SimpleBar className='modal-content-container'>
						<Contact />
					</SimpleBar>

export default class SpotlightStores extends Component {
	constructor(props) {
		super(props);
		this.state = { isModalOpen: false };
	  }
	
	  toggleModal = () => {
		this.setState({
		  isModalOpen: !this.state.isModalOpen
		});
	  }

	render() {
		return(
			<div className='row min-height-400 border component' id='spotlight-stores'>
				<div className='col-md-12 text-center'>
					<h2 className='section-heading'>12 Spotlight Store Placements</h2>
					<ul className='sub-heading-list'>
						<li>
							<span>Global one-click to merchant page</span>
						</li>
						<li>
							<span className='glyphicon glyphicon-stop' aria-hidden='true'></span>
							<span>Sitewide opportunity</span>
						</li>
						<li>
							<span className='glyphicon glyphicon-stop' aria-hidden='true'></span>
							<span>Full page width placement</span>
						</li>
					</ul>
				</div>
				<div className='col-md-5 component-content-left'>
					<h2>
						In-Sight, In-Mind
					</h2>
					<p>
						No matter where you are on the site, your company logo will follow. Our spotlight stores placement offers sitewide placement of your company logo ensuring quick one-click access to your branded store page.
					</p>
					<div className='btn-container'>
						<button className='btn-1' onClick={this.toggleModal.bind(this)}>Request More Info</button>
					</div>
					{this.state.isModalOpen ? 
						<Modal
							text={modalContent}
							open={this.state.isModalOpen}
							onClose={this.toggleModal.bind(this)}
						/> : ''}
				</div>
				<div className='col-md-7'>
					<div className='spotlight-img-container'>
						<img src='https://cdn.couponology.com/images/mediakit-spotlight-stores.png' alt='spotlight stores' />
					</div>
				</div>
			</div>
		);
	}
}